import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-file-txt-filled",
  "use": "rt-base-file-txt-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-file-txt-filled\"><path d=\"M854.3 288.6L639.4 73.2c-6.1-6.1-14.3-9.2-22.5-9.2H192.2C174.3 64 160 78.3 160 96.2v831.5c0 17.9 14.3 32.2 32.2 32.2h639.5c17.9 0 32.2-14.3 32.2-32.2V311.2c0.1-8.7-3.5-16.4-9.6-22.6z m-223.1 260h-81.3V786H468V548.6h-80.8v-69.1h244.6v69.1h-0.6zM602 326V137.7L790.3 326H602z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/file-txt-filled.svg
// module id = 1744
// module chunks = 137